module.exports = __webpack_public_path__ + "2dbd8bc16e70e47de599e06138b5fd03.png";